export default __webpack_public_path__ + "static/media/abalance.e68e97c5.svg";